import { html, LitElement, nothing } from 'lit';

class ProductCardSkeleton extends LitElement {
  static properties = {
    hideSwatches: { type: Boolean, attribute: true },
    hideWishlist: { type: Boolean, attribute: true },
    swatchLength: { type: Number, attribute: true },
  };

  createRenderRoot() {
    return this;
  }

  render() {
    return html`
      <div class="product-card-skeleton">
        <div class="product-card-skeleton__media-container">
          <div class="product-card-skeleton__image"></div>
        </div>
        <div class="product-card-skeleton__info">
          <div class="product-card-skeleton__title-container">
            <div class="product-card-skeleton__title"></div>
            ${!this.hideWishlist ? html`<div class="product-card-skeleton__wishlist"></div>` : nothing}
          </div>
          <div class="product-card-skeleton__price"></div>
          ${!this.hideSwatches ? html`
            <div class="product-card-skeleton__swatches">
              ${[...Array(Math.min(this.swatchLength || 0, 5))].map(() => html`<div class="product-card-skeleton__swatch"></div>`)}
            </div>` : nothing}
        </div>
      </div>
    `;
  }
}

window.customElements.get('product-card-skeleton') ||
  window.customElements.define('product-card-skeleton', ProductCardSkeleton);
